import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from '../../../../shared/models/subject';
import { AuditService } from 'app/shared/services/audit.service';
import { SelectDateComponent } from 'app/components/selectDate/selectDate.component';
import { MessageBoxComponent, MessageBoxParameters, MessageBoxType } from 'app/components/messageBox/messageBox.component';
import { DataGridComponent } from 'app/components/data-grid/data-grid.component';
import { AuditComponent } from 'app/main/content/audits/audit/audit.component';

@Component({
  selector: 'audit-list-widget',
  templateUrl: './audit-list-widget.component.html',
  styleUrls: ['./audit-list-widget.component.scss'],
  animations: fuseAnimations,
})
export class AuditListWidgetComponent implements OnInit {

  _subject: Subject;
  title = '';
  data = [];
  columns = [];
  selected: any;

  @Input() set subject(val: Subject) {
    if (val){
      this.update(val);
    }
  }

  @ViewChild(DataGridComponent) dataGrid: DataGridComponent;

  constructor(
    private auditService: AuditService,
    public dialog: MatDialog) {
  }

  ngOnInit() {
    this.title = 'Audit Trail';
    this.columns = [
      // {name: 'Keep', prop: 'keep', dataType: 'checkbox', maxWidth: 80, allowEditing: true },
      {name: 'Summary', prop: 'summary', width: 250}, 
      {name: 'Type', prop: 'type' },
      {name: 'Date Time', prop: 'dateCreated', dataType: 'datetime' },
      {name: 'User', prop: 'userName'}];
  }

  select(row) {
    this.selected = row;
  }

  update(subject?: Subject) {
    subject = subject || this._subject;
    if (subject) { this._subject = subject; }
    if (this._subject) {
      this.auditService.getAllDataForSubject(this._subject).subscribe((data) => {
        if (data){
          if (!this.data || (this.data.length === 0) || (this.data.length < data.length)){
            this.data = [...data];
            this.data.map((x) => {
              x.userName = (x.createdBy) ? x.createdBy.firstName + ' ' + x.createdBy.lastName : 'System';
              x.json = JSON.parse(x.details);
              (x as any).canEdit = !x.locked;
            });
          }
          else{
            this.data.forEach((x) => {
              const match = data.find((i) => i.id === x.id);
              if (match){
                x.keep = match.keep;
              }
            });
          }
        }
      });
    }
  }

  edit(row) {
    const editrow = this.data.find((x) => x.id === row.id);
    this.dialog.open(AuditComponent, {
      data: editrow,
      autoFocus: false,
    });
  }

  rowUpdated(e){
    if (e.data){
      this.auditService.save(e.data, `Audit ${e.data.keep ? 'marked' : 'unmarked'} as Keep`);
    }
  }

  purge(){
    const currentDate = new Date();
    this.dialog.open(SelectDateComponent, { 
      data: {
        title: 'Purge Audit',
        message: 'Please select the date range for the audit purge',
        maxDate: currentDate,
        date1: null,
        date2: currentDate,
        showDate2: true,
      },
    }).afterClosed().subscribe((data) => {
      if (data){
        const date1 = data.date1;
        const date2 = data.date2;
        const info = new MessageBoxParameters('Are you sure you want to purge audit records between these dates?', 'Confirm', MessageBoxType.Confirm, true);
        this.dialog.open(MessageBoxComponent, { data: info, disableClose: false, autoFocus: false }).afterClosed().subscribe((result) => {
          if (result === 'confirm'){
            this.data.length = 0;
            this.auditService.purge(date1, date2);
          }
        });
    }});
  }
}
